import { render, staticRenderFns } from "./ButtonTab.vue?vue&type=template&id=6860c959&scoped=true"
import script from "./ButtonTab.vue?vue&type=script&lang=js"
export * from "./ButtonTab.vue?vue&type=script&lang=js"
import style0 from "./ButtonTab.vue?vue&type=style&index=0&id=6860c959&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6860c959",
  null
  
)

/* custom blocks */
import block0 from "./ButtonTab.vue?vue&type=custom&index=0&blockType=platform-tab&%3AtabData=tabData&%40tabChange=tabChange"
if (typeof block0 === 'function') block0(component)

export default component.exports